export const tr = {
    'add-description': {
        one: 'Kreatif {count} reklamda değiştirilecek.',
        some: 'Kreatif {count} reklamda değiştirilecek.',
        many: 'Kreatif {count} reklamda değiştirilecek.',
        none: 'Kreatif {count} reklamda değiştirilecek.'
    },
    'duplicate-error': 'Toplu düzenlemelerde boyutların her biri için yalnızca bir görsel seçilebilir',
    warning:
        'Reklamın kreatifi sadece aynı boyutta olan ve orijinaliyle aynı şekilde oluşturulmuş bir kreatifle değiştirilebilir.'
};
